import script from "./content.widget.vue?vue&type=script&lang=ts&setup=true"
export * from "./content.widget.vue?vue&type=script&lang=ts&setup=true"

import "./content.widget.vue?vue&type=style&index=0&id=750e9556&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-750e9556"]])

export default __exports__